<ngx-charts-line-chart
  [view]="view"
  [showXAxisLabel]="false"
  [showYAxisLabel]="false"
  [scheme]="colorScheme"
  [xAxis]="true"
  [yAxis]="true"
  [timeline]="false"
  [results]="data"
  [autoScale]="true"
>
  <ng-container>
    <ng-template #seriesTooltipTemplate let-model="model">
      <div class="tooltip">
        <span>
          {{ model[0]?.series }}
          {{
            model[0]?.value | currency : 'MXN' : 'symbol-narrow' : '1.0-0'
          }}</span
        >
      </div>
    </ng-template>
    <ng-template #tooltipTemplate let-model="model">
      <div class="tooltip">
        <span>{{ model.name | date : 'dd/MM/yyyy' }}</span>
        <p>
          Valor:
          {{ model.value | currency : 'MXN' : 'symbol-narrow' : '1.0-0' }}
        </p>
        <p *ngIf="model?.twr">Rendimiento: {{ model.twr | percent : '1.2' }}</p>
      </div>
    </ng-template></ng-container
  >
</ngx-charts-line-chart>
